import { Link, NavLink } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { useAccessRequestStore } from '@/stores/accessRequestStore';
import { useMessageStore } from '@/stores/messageStore';
import { useNotificationStore } from '@/stores/notificationStore';
import { getMainNavigationItems } from './navigation';

export function SideNavigation() {
  const { userData } = useAuthStore();
  const unreadTotal = useMessageStore((state) =>
    state.conversations.reduce((sum, conversation) => sum + Math.max(0, conversation.unreadCount), 0)
  );
  const unreadVerificationResultCount = useNotificationStore(
    (state) => state.unreadVerificationResultCount
  );
  const accessRequests = useAccessRequestStore((state) => state.requests);
  const isDonor = userData?.role === 'donor';
  const unreadBadgeText = unreadTotal > 99 ? '99+' : String(unreadTotal);
  const pendingAccessRequestCount = isDonor
    ? accessRequests.filter((request) => request.status === 'pending').length
    : 0;
  const myPageBadgeCount = unreadVerificationResultCount + pendingAccessRequestCount;
  const myPageBadgeText = myPageBadgeCount > 99 ? '99+' : String(myPageBadgeCount);
  const navItems = getMainNavigationItems(isDonor);

  return (
    <aside className="hidden md:flex md:w-64 md:flex-col md:h-screen md:sticky md:top-0 md:bg-white md:border-r md:border-neutral-200">
      <div className="h-16 px-6 border-b border-neutral-100 flex items-center">
        <Link to="/dashboard" className="inline-flex items-center">
          <span className="text-xl font-heading tracking-[0.15em] text-luxury-dark">
            KULUM
          </span>
        </Link>
      </div>

      <nav className="flex-1 p-4 space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `w-full flex items-center gap-3 px-4 py-3 rounded-xl transition ${
                isActive
                  ? 'bg-copper/10 text-copper'
                  : 'text-neutral-600 hover:text-copper hover:bg-neutral-100'
              }`
            }
          >
            <div className="relative">
              <item.icon className="w-5 h-5" />
              {item.to === '/messages' && unreadTotal > 0 && (
                <span className="absolute -top-2 -right-2 min-w-[1rem] h-[1rem] px-1 rounded-full bg-copper text-white text-[10px] leading-none font-bold flex items-center justify-center">
                  {unreadBadgeText}
                </span>
              )}
              {item.to === '/mypage' && myPageBadgeCount > 0 && (
                <span className="absolute -top-2 -right-2 min-w-[1rem] h-[1rem] px-1 rounded-full bg-copper text-white text-[10px] leading-none font-bold flex items-center justify-center">
                  {myPageBadgeText}
                </span>
              )}
            </div>
            <span className="text-sm font-medium">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
